export default {"src":"/_next/static/media/bounties.b4de5937.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};